<template>
  <b-container id="page">
    <div class="lefttext">选择开卡区域</div>

    <div class="wrapper">
      <div
        class="wrapper-content"
        v-for="(item, index) in areas"
        :key="index"
        @click="itemClick(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "ApplyCard",
  data() {
    return {
      areas: [
        {
          id: "",
          name: "安徽",
        },
        {
          id: "",
          name: "北京",
        },
        {
          id: "",
          name: "福建",
        },
        {
          id: "",
          name: "重庆",
        },
        {
          id: "",
          name: "甘肃",
        },
        {
          id: "",
          name: "广东",
        },
        {
          id: "",
          name: "广西",
        },
        {
          id: "",
          name: "贵州",
        },
        {
          id: "",
          name: "海南",
        },
        {
          id: "",
          name: "河北",
        },
        {
          id: "",
          name: "河南",
        },
        {
          id: "",
          name: "黑龙江",
        },
        {
          id: "",
          name: "湖北",
        },
        {
          id: "",
          name: "湖南",
        },
        {
          id: "",
          name: "吉林",
        },
        {
          id: "",
          name: "江苏",
        },
        {
          id: "",
          name: "江西",
        },
        {
          id: "",
          name: "辽宁",
        },
        {
          id: "",
          name: "内蒙",
        },
        {
          id: "",
          name: "宁夏",
        },
        {
          id: "",
          name: "青海",
        },
        {
          id: "",
          name: "山东",
        },
        {
          id: "",
          name: "山西",
        },
        {
          id: "",
          name: "陕西",
        },
        {
          id: "",
          name: "上海",
        },
        {
          id: "",
          name: "四川",
        },
        {
          id: "",
          name: "天津",
        },
        {
          id: "",
          name: "西藏",
        },
        {
          id: "",
          name: "新疆",
        },
        {
          id: "",
          name: "云南",
        },
        {
          id: "",
          name: "浙江",
        },
        {
          id: "",
          name: "",
        },
      ],
    };
  },
  methods: {
    itemClick: function (item) {
      //this.$router.push('cardTheme')
      this.$router.push({
        name: "CardTheme",
        query: {
          area: item.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.lefttext {
  text-align: left;
}

.wrapper {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.wrapper-content {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/ApplyCard.vue